/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { LeafletEventHandlerFnMap } from 'leaflet';
import L from 'leaflet';
import type { ReactNode } from 'react';
import React, { useId, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import type { MarkerProps } from 'react-leaflet';
import { Marker } from 'react-leaflet';
import styles from './EnhancedMarker.module.scss';

interface EnhancedMarkerProps extends Omit<MarkerProps, 'icon' | 'eventHandlers'> {
	element: ReactNode;
	eventHandlers?: LeafletEventHandlerFnMap;
}

const EnhancedMarker = ({ eventHandlers, element, ...rest }: EnhancedMarkerProps) => {
	const [markerRendered, setMarkerRendered] = useState(false);
	const id = 'marker-' + useId();

	const icon = useMemo(
		() =>
			L.divIcon({
				className: styles.markerIcon,
				html: `<div id="${id}"></div>`,
			}),
		[id],
	);

	return (
		<>
			<Marker
				icon={icon}
				eventHandlers={{
					...eventHandlers,
					add: (...arguments_) => {
						setMarkerRendered(true);

						if (eventHandlers?.add) eventHandlers.add(...arguments_);
					},
					remove: (...arguments_) => {
						setMarkerRendered(false);

						if (eventHandlers?.remove) eventHandlers.remove(...arguments_);
					},
				}}
				{...rest}
			/>
			{markerRendered && createPortal(element, document.querySelector('#' + id)!)}
		</>
	);
};

export default EnhancedMarker;
